import { useGetAllDealerAddressProfitQuery, useCreateDealerAddressProfitMutation, useUpdateDealerAddressProfitMutation } from '../../../../../api';

import { useState } from 'react';
import { useLanguage } from '../../../../../contexts/LanguageContext';

export const useProfitData = ({ dealerAddressBrandId, dealerAddress, model, brand, pageSize = 10, enabled = true }) => {
    const { th } = useLanguage();

    // 1️⃣ Sayfa state'i burada
    const [pageNumber, setPageNumber] = useState(1);

    // 2️⃣ RTK Query çağrısı — pageNumber parametreye bağlı!
    const {
        data = { items: [], count: 0 },
        isLoading,
        isFetching,
        isError,
        error,
        refetch
    } = useGetAllDealerAddressProfitQuery(
        {
            dealerAddressBrandId,
            model,
            brand,
            pageNumber,
            pageSize
        },
        { skip: !enabled }
    );

    const [createProfit] = useCreateDealerAddressProfitMutation();
    const [updateProfit] = useUpdateDealerAddressProfitMutation();

    const columns = [
        { field: 'startDate', header: th('customerAddressBrand.tabs.profit.columns.startDate'), bodyField: 'startDate' },
        { field: 'endDate', header: th('customerAddressBrand.tabs.profit.columns.endDate'), bodyField: 'endDate' },
        { field: 'commercialProfit', header: th('customerAddressBrand.tabs.profit.columns.commercialProfit') }
    ];

    const save = async (formData) => {
        try {
            if (formData.id) {
                const payload = {
                    id: formData.id,
                    dealerAddressBrandId: dealerAddressBrandId,
                    startDate: formData.startDate ? new Date(formData.startDate).toISOString() : null,
                    endDate: formData.endDate ? new Date(formData.endDate).toISOString() : null,
                    commercialProfit: Number(formData.commercialProfit) || 0
                };
                await updateProfit(payload).unwrap();
                console.log('✅ Profit güncellendi:', formData);
            } else {
                const payload = {
                    dealerAddressBrandId: dealerAddressBrandId,
                    siteUseId: dealerAddress.id,
                    model: model?.id || 0,
                    brand: brand?.id || 0,
                    startDate: formData.startDate ? new Date(formData.startDate).toISOString() : null,
                    endDate: formData.endDate ? new Date(formData.endDate).toISOString() : null,
                    commercialProfit: Number(formData.commercialProfit) || 0
                };
                await createProfit(payload).unwrap();
                console.log('✅ Profit oluşturuldu:', formData);
            }
            refetch();
        } catch (error) {
            console.error('❌ Profit kayıt hatası:', error);
        }
    };

    return {
        payments: data.items,
        count: data.count,
        isLoading: isLoading || isFetching,
        columns,
        save,
        refetch,
        pageNumber,
        setPageNumber,
        pageSize
    };
};
